document.addEventListener("DOMContentLoaded", function () {
    const tabsNavItems = document.querySelectorAll(".tabs-nav ul li");

    tabsNavItems.forEach(item => {
        item.addEventListener("click", function (event) {
            setTimeout(() => {
            }, 100);
        });
    });
});
